var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.tableData}}),_c('Page',{staticStyle:{"text-align":"center","margin-top":"20px"},attrs:{"total":_vm.total,"current":_vm.pageNum,"page-size":_vm.pageSize,"show-total":""},on:{"update:current":function($event){_vm.pageNum=$event},"on-change":_vm.getList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }